import React, { useState, useEffect } from 'react';
import { register } from '../../../i18n';
import LessonService from '../../services/LessonService';
import '../../../css/Tools.scss';
import '../../../css/Accessibility.scss';

const t = register('ToolNames');

// Default fallback languages
const defaultLanguageNames = {
  en: 'English',
  es: 'Spanish',
  fr_fr: 'French',
  de_de: 'German',
  it_it: 'Italian',
  pt: 'Portuguese',
  nl_nl: 'Dutch',
  sv_se: 'Swedish',
  da_dk: 'Danish',
  no_nb: 'Norwegian',
  fi_fi: 'Finnish',
  is_is: 'Icelandic',
  ca_es: 'Catalan',
  eu_es: 'Basque',
  gl_es: 'Galician',
  ar_ar: 'Arabic',
  he_il: 'Hebrew',
  ja_jp: 'Japanese',
  ko_kr: 'Korean',
  zh_cn: 'Chinese',
  lv_lv: 'Latvian'
};

const WebReaderLanguageSelector = ({ isOpen, onSelect, onClose }) => {
  const [languageNames, setLanguageNames] = useState(defaultLanguageNames);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const translationLanguages = await LessonService.fetchTranslationLanguages();
        if (translationLanguages) {
          setLanguageNames(translationLanguages);
        }
      } catch (error) {
        console.error('Error fetching translation languages:', error);
        // Keep using default languages on error
      }
    };

    fetchLanguages();
  }, []);

  if (!isOpen) return null;

  const languages = Object.keys(languageNames);

  return (
    <div
      aria-labelledby='webreader-translate-dialog-title'
      className='dropdown-menu-popup open webreader-language-selector'
      role='menu'
    >
      <div className='selectorBody'>
        <h2 className='title-label basic webreader-language-title' id='webreader-translate-dialog-title'>
          {t('translateTool', 'Select translation language')}
        </h2>
        <div className='control-container webreader-language-list'>
          {languages.map((lang) => (
            <button
              key={lang}
              className='tools-btn webreader-language-button'
              onClick={() => onSelect(lang)}
              type='button'
            >
              {languageNames[lang] || lang}
            </button>
          ))}
        </div>
        <div className='control-container webreader-language-actions'>
          <button
            className='tools-btn'
            onClick={onClose}
            type='button'
          >
            {t('closeLabel', 'Cancel')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default WebReaderLanguageSelector;

// Export for backward compatibility
export { defaultLanguageNames as languageNames };
